import React, { ChangeEvent, useState } from 'react';
import styles from './NewQuestion.module.scss';
import { Input, Select } from '@tcc-online/input-components';
import { QuestionType } from '../../../../../../types/project/360/Question';
import { useTranslate } from 'react-translate.ts';
import { NumberSchema, ObjectSchema, StringSchema } from 'yup';
import useDebounce from '../../../../../../../helpers/useDebounce';

interface Option {
    value: QuestionType;
    label: string;
}

interface NewQuestionProps {
    options: Option[];
    onCreate: (text: string, type: QuestionType) => void;
}

interface Values {
    text?: string;
    type?: QuestionType;
}

const validationSchema = new ObjectSchema({
    text: new StringSchema().required().nonNullable(),
    type: new NumberSchema().required().nonNullable(),
});

export default function NewQuestion(props: NewQuestionProps) {
    const { options, onCreate } = props;
    const [values, setValues] = useState<Values>({});
    const translate = useTranslate();
    const debounce = useDebounce();

    return (
        <div className={styles.wrapper}>
            <Input
                onChange={handleChange(values)}
                placeholder={translate('Otázka')}
            />
            <Select<Option>
                options={options}
                onChange={handleTypeChange(values)}
                label={translate('Type')}
            />
        </div>
    );

    function handleChange(values: Values) {
        return async (event: ChangeEvent<HTMLInputElement>) => {
            const text = event.target.value;
            const newValues = { ...values, text };
            setValues(newValues);
            await debounce(create, newValues);
        };
    }

    function handleTypeChange(values: Values) {
        return async (type: QuestionType) => {
            const newValues = { ...values, type };
            setValues(newValues);
            await create(newValues);
        };
    }

    async function create(values: Values) {
        if (
            values.text &&
            values.type !== null &&
            values.type !== undefined &&
            (await validate(values))
        ) {
            onCreate(values.text, values.type);
        }
    }

    async function validate(values: Values) {
        return await validationSchema.validate(values);
    }
}
